module.exports = __webpack_public_path__ + "static/media/Nutrition2024.5ae88790.png";